import "core-js/modules/es.array.map";
import React from "react";
import DragRail from "web/react/components/drag-rail/drag-rail";
import ProductCard from "web/react/components/product-card/product-card";
import analytics from "web/script/analytics/analytics";
import classnames from "classnames";
import styles from "./top-products.css";
export function TopProducts(_ref) {
  var title = _ref.title,
      products = _ref.products;
  var id = "top-50-products";

  function handleDrag() {
    analytics.event("rail", "drag", "homepage-top-products");
  }

  return React.createElement(DragRail, {
    id: id,
    onDragStart: handleDrag,
    className: styles.wrapper
  }, React.createElement("div", {
    className: styles.productsContainer
  }, React.createElement("h2", {
    className: classnames(styles.productCard, styles.titleCard)
  }, React.createElement("span", {
    className: styles.titleCardText
  }, title)), products.map(function (product) {
    return React.createElement(ProductCard, {
      className: styles.productCard,
      key: product.id,
      product: product,
      imageSize: "feed",
      scrollParentId: id
    });
  })));
}
export default TopProducts;